import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { LVStrings } from "@my-dld/assets/strings";
import { ProcedureIDs } from "@10x/tabu-mobile-api/dist/requests/entity";

export interface TabuService {
	ID: number;
	Name?: LocaleValue | { NameAr?: string; NameEn: string };
	Description?: LocaleValue | { NameAr?: string; NameEn: string };
	NameAr?: string;
	NameEn: string;
	DescriptionAr?: string;
	DescriptionEn?: string;
	HappinessServiceId?: number;
	IconURL?: string;
	RequirePropertySeclect?: boolean;
	IsActive?: boolean;
	Identity?: number;
	icon?: string;
}

export const TWIMC: TabuService = {
	"ID": 125,
	"Name": {
		"NameAr": "طلب إصدار شهادة بيان املاك العميل (لمن يهمه الامر)",
		"NameEn": "To whom it may concern",
	},
	"NameAr": "طلب إصدار شهادة بيان املاك العميل (لمن يهمه الامر)",
	"NameEn": "To whom it may concern",
	"Description": {
		"NameAr": "تتيح هذه الخدمة للمتعاملين القيام بتسجيل طلب إصدار شهادة بيان أملاك المتعامل أو شهادة استيفاء بالمتطلبات الخاصة بإدارة العقارات.",
		"NameEn": "This service allows clients to apply for issuing a Statement of Customer Property or a Certificate of Satisfaction of Property Management Requirements.",
	},
	"DescriptionAr": "تتيح هذه الخدمة للمتعاملين القيام بتسجيل طلب إصدار شهادة بيان أملاك المتعامل أو شهادة استيفاء بالمتطلبات الخاصة بإدارة العقارات.",
	"DescriptionEn": "This service allows clients to apply for issuing a Statement of Customer Property or a Certificate of Satisfaction of Property Management Requirements.",
	"IconURL": "",
	"RequirePropertySeclect": false,
	"HappinessServiceId": 438,
	"IsActive": true,
	"Identity": 125,
};

export const PropertyDetailCertService: TabuService = {
	"ID": 225,
	"Name": {
		"NameAr": LVStrings.property_detail_certificate.ar ?? "",
		"NameEn": LVStrings.property_detail_certificate.en ?? "",
	},
	"NameAr": LVStrings.property_detail_certificate.ar ?? "",
	"NameEn": LVStrings.property_detail_certificate.en ?? "",
	"Description": {
		"NameAr": "تتيح هذه الخدمة التقدم بطلب إصدار شهادة عقار تفصيلية (عقار واحد فقط) وتدرج فيها (بيانات المالك و العقار والرهن والحجز والإيقاف وبيانات المشروع) وذلك بناء على طلب المتعامل.",
		"NameEn": "This service allows applying for issuing a detailed property certificate (only one property) and include (owner data, property data, mortgage, reservation, suspension and Project data).",
	},
	"DescriptionAr": "تتيح هذه الخدمة التقدم بطلب إصدار شهادة عقار تفصيلية (عقار واحد فقط) وتدرج فيها (بيانات المالك و العقار والرهن والحجز والإيقاف وبيانات المشروع) وذلك بناء على طلب المتعامل.",
	"DescriptionEn": "This service allows applying for issuing a detailed property certificate (only one property) and include (owner data, property data, mortgage, reservation, suspension and Project data).",
	"IconURL": "",
	"RequirePropertySeclect": true,
	"HappinessServiceId": 0,
	"IsActive": true,
	"Identity": 225,
	"icon": "property_detail_certificate",
};

export const SitePlan: TabuService = {
	"icon": "site_plan",
	"ID": 20,
	"Name": {
		"NameAr": "طلب اصدار خارطة",
		"NameEn": "Site Plan",
	},
	"NameAr": "طلب اصدار خارطة",
	"NameEn": "Site Plan",
	"DescriptionAr": "تتيح هذه الخدمة للمتعاملين  التقدم بطلب لإصدار خارطة لعقار حسب أنواع الخرائط المعتمدة في خدمات قسم المخططات في الدائرة.",
	"DescriptionEn": "This Service enables clients to request the issuance of a map as per the approved plans from the Survey Section at Land Department.",
	"IconURL": "",
	"RequirePropertySeclect": true,
	"HappinessServiceId": 474,
	"IsActive": true,
	"Identity": 20,
};

export const ElectronicTitleDeed: TabuService = {
	"icon": "electronic_title_deed",
	"ID": -1,
	"NameAr": "سند الملكية الإلكتروني",
	"NameEn": "Electronic Title Deed",
	"DescriptionAr": "تتيح هذه الخدمة للمتعاملين  التقدم بطلب لإصدار سند ملكية الكترونى.",
	"DescriptionEn": "This Service enables clients to request the issuance of an electronic Title Deed.",
	"IconURL": "",
	"RequirePropertySeclect": true,
	"HappinessServiceId": 0,
	"IsActive": true,
	"Identity": -1,
};

export const PropertyValuation: TabuService = {
	"icon": "prop_valuation",
	"ID": 24,
	"Name": {
		"NameAr": "شهادة تثمين",
		"NameEn": "Valuation Certificate",
	},
	"NameAr": "شهادة تثمين",
	"NameEn": "Valuation Certificate",
	"DescriptionAr": "تتيح هذه الخدمة للمتعاملين  التقدم بطلب لإصدار شهادة تثمين عقارى.",
	"DescriptionEn": "This Service enables clients to request the issuance of a property valuation certificate.",
	"IconURL": "",
	"RequirePropertySeclect": true,
	"HappinessServiceId": 480,
	"IsActive": true,
	"Identity": 24,
};

export const IPV: TabuService = {
	"icon": "iprop_valuation",
	"ID": 29,
	"Name": {
		"NameAr": "تقييم عقار داخلى",
		"NameEn": "Internal Property Evaluation",
	},
	"NameAr": "تقييم عقار داخلى",
	"NameEn": "Internal Property Evaluation",
	"DescriptionAr": "إجراء لتقييم عقار بغرض الهبة",
	"DescriptionEn": "Procedure to evaluate the property for grant purpose",
	"IconURL": "",
	"RequirePropertySeclect": true,
	"HappinessServiceId": 480,
	"IsActive": true,
	"Identity": 29,
};
export const IPVTypes = [
	{
		Identity: 4,
		NameAr: "الهبة",
		NameEn: "Grant",
	},
];

export const LossCertificate: TabuService = {
	"icon": "loss_cert",
	"ID": 19,
	"Name": {
		"NameAr": "طلب إصدار ملكية بدل فاقد",
		"NameEn": "Loss Certificate",
	},
	"NameAr": "طلب إصدار ملكية بدل فاقد",
	"NameEn": "Loss Certificate",
	"DescriptionAr": "تتيح هذه الخدمة للعملاء القيام بتسجيل طلب إصدار ملكية بدل تالف او فاقد عن طريق طلب من مالك الأرض أو العقار، و تصدر الملكية بعد نشر إعلان في الصحف و بعد مرور الفترة القانونية تحسبا لأي اعتراض",
	"DescriptionEn": "This service enables customers who are landlords to request the issuance of a replacement of damaged or lost title deed."
		+ "The title deed is issued after posting an advertisement in the newspaper and after the expiry of the legal period, to avoid any objection. ",
	"IconURL": "",
	"RequirePropertySeclect": true,
	"HappinessServiceId": 530,
	"IsActive": true,
	"Identity": 19,
};
export const BCSReClassification = {
	"icon": "bcs_reclassification",
	"screen": "bcs_reclassification",
	"ID": ProcedureIDs.BCS_RE_CLASSIFICATION,
	"Name": {
		"NameAr": LVStrings.bcs_reclassification.ar,
		"NameEn": LVStrings.bcs_reclassification.en,
	},
	"NameAr": LVStrings.bcs_reclassification.ar,
	"NameEn": LVStrings.bcs_reclassification.en,
	"DescriptionAr": "bcs_reclassification",
	"DescriptionEn": "bcs_reclassification",
	"IconURL": "",
	"RequirePropertySeclect": true,
	"HappinessServiceId": 0,
	"IsActive": true,
	"Error": undefined,
	"Identity": ProcedureIDs.BCS_RE_CLASSIFICATION,
};
